export const ACTION_SET_LIST_USER            = 'ACTION_SET_LIST_USER';
export const ACTION_ECOMMERCE_CLIENT         = 'ACTION_ECOMMERCE_CLIENT';

//ENCUESTAMULTIPLE
